<template>
  <div class="tuolele-main-box set-combo">
    <div class="tuolele-main-search tuolele-main-search-item">
      <el-date-picker
        v-model="listQuery.begin_time"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="开始日期"
      />
      <i class="split-time" style="margin-left:10px">至</i>
      <el-date-picker
        v-model="listQuery.end_time"
        style="margin-left:10px"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="结束日期"
      />
      <el-button type="primary" style="margin-left:10px" @click="fnGetLists">查询</el-button>
      <div class="fn-right export-btn">
        <el-button type="success" @click="exportExcel">导出Excel表</el-button>
      </div>
    </div>
    <div class="tuolele-main-content">
      <el-table :data="staticsLists" border show-summary :summary-method="getSummaries">
        <el-table-column prop="day" label="日期" />
        <el-table-column prop="channel_name" label="渠道名称" />
        <el-table-column label="批改张数" prop="pigai">
          <template slot-scope="{row}">
            <span>{{ row.correct_num +row.return_num }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="supply_num" label="录入张数" />
        <el-table-column prop="mistake_supply_num" label="错题录入张数" />
      </el-table>
    </div>
  </div>
</template>
<script>
import Tool from '@/assets/js/tool.js'
export default {
  name: 'CorrectStatistics',
  components: {

  },
  data() {
    return {
      listQuery: {
        begin_time: '',
        end_time: ''
      },
      staticsLists: []

    }
  },
  mounted() {
    // this.fnGetLists()
  },
  methods: {
    exportExcel() {
      const tHeader = [
        '日期',
        '渠道',
        '批改张数',
        '录入张数',
        '错题录入张数'
      ]
      const filterVal = [
        'day',
        'channel_name',
        'pigai',
        'supply_num',
        'mistake_supply_num'
      ]
      let list = JSON.stringify(this.staticsLists)
      list = JSON.parse(list)
      list.forEach(e => {
        e.pigai = e.correct_num + e.return_num
        e.supply_num = parseFloat(e.supply_num)
        e.mistake_supply_num = parseFloat(e.mistake_supply_num)
      })
      Tool.exportExcel(tHeader, filterVal, list, '批改张数统计' + Tool.nowTime())
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总张数'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (column.property == 'pigai') {
          const pigaivalues = data.map(item => Number(item['correct_num'] + item['return_num']))
          sums[index] = pigaivalues.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] += ' 张'
        } else if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] += ' 张'
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    fnGetLists() {
      this.$http.getChannelFeeFlow(this.listQuery).then(res => {
        this.staticsLists = res.data.list
      })
    }

  }
}
</script>
<style lang="scss">
  .wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.set-combo {
  .self-table {
    margin-top: 0 !important;
  }
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-form-item__content {
    margin: 0 20px 0 12px;
  }
  .el-button.el-button-confirm {
    width: 80px !important;
  }

}
::v-deep .el-table{
     .el-table__footer-wrapper tbody td{
      color: red !important;
    }
  }
</style>
